import { render, staticRenderFns } from "./revokeTip.vue?vue&type=template&id=f37fdb5a&scoped=true"
import script from "./revokeTip.vue?vue&type=script&lang=js"
export * from "./revokeTip.vue?vue&type=script&lang=js"
import style0 from "./revokeTip.vue?vue&type=style&index=0&id=f37fdb5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37fdb5a",
  null
  
)

export default component.exports